import React, { useEffect, useRef, useState, useContext } from "react";
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import { useMediaQuery } from "react-responsive";

// Context
import { MainContext } from "../../components/context/context";

// Sections
import BearBullChoose from "./BearBullChoose";
import BearBullType from "./BearBullType";
import BearBullAllowlist from "./BearBullAllowlist";
import BearBullTeam from "./BearBullTeam";
import BearBullEcosystem from "./BearBullEcosystem";
import Header from "./header"
import { ReactComponent as ScrollToTopReversed } from "../../assets/svg/scroll-to-reversed.svg";

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

const BearBullLanding = () => {
  const isMobile = useMediaQuery({ query: "(max-width: 480px)" });

  const sectionRefs = useRef([]);
  const isScrollingRef = useRef(false);
  const [currentSection, setCurrentSection] = useState(0);
  const [isNavActive, setIsNavActive] = useState(false);
  const { isSoundEnabled, setIsSoundEnabled } = useContext(MainContext);

  useEffect(() => {
    gsap.to(window, { scrollTo: 0, duration: 0.5 });

    const triggerLanding = ScrollTrigger.create({
      trigger: ".bear-bull-ecosystem", // any visible section
      start: "top bottom",
      end: "top top",
      onEnter: () => setIsNavActive(true),
      onLeaveBack: () => setIsNavActive(false),
    });

    return () => {
      triggerLanding.kill();
    };
  }, []);
const handleScrollTop = () => {
  gsap.to(window, {
    scrollTo: {
      y: sectionRefs.current[0],
      offsetY: 0, // You can tweak this if you need a bit of spacing
    },
    duration: 0.9,
    ease: "power2.out",
    onComplete: () => {
      setCurrentSection(0);
    },
  });
};


  useEffect(() => {
    if (isMobile) return;
  
    let scrollTimeout;
  
    const onWheel = (event) => {
      event.preventDefault();
      if (isScrollingRef.current) return;
  
      const direction = event.deltaY > 0 ? 1 : -1;
      const nextSection = currentSection + direction;
  
      if (nextSection < 0 || nextSection >= sectionRefs.current.length) return;
  
      isScrollingRef.current = true;
      setCurrentSection(nextSection);
  
      gsap.to(window, {
        scrollTo: {
          y: sectionRefs.current[nextSection],
          offsetY: 0,
          autoKill: false,
        },
        duration: 0.6,
        ease: "power3s.out",
      
        onComplete: () => {
          scrollTimeout = setTimeout(() => {
            isScrollingRef.current = false;
          }, 50);
        }// longer debounce for smoother transitions
     
      });
    };
  
    window.addEventListener("wheel", onWheel, { passive: false });
  
    return () => {
      clearTimeout(scrollTimeout);
      window.removeEventListener("wheel", onWheel);
    };
  }, [currentSection, isMobile]);
  


  return (
    <> 
     <div className="bear-bull-wrapper">
    
     <div ref={(el) => (sectionRefs.current[0] = el)} >
<BearBullChoose currentSection={currentSection} setCurrentSection={setCurrentSection} />
</div>

{/*<div  className="bear-bull-page">
<div className="background-element" />


<div ref={(el) => (sectionRefs.current[1] = el)} className="section">
<BearBullEcosystem />
</div>

<div ref={(el) => (sectionRefs.current[2] = el)} className="section">
<BearBullType />
</div>

<div ref={(el) => (sectionRefs.current[3] = el)} className="section">
<BearBullAllowlist />
</div>

<div ref={(el) => (sectionRefs.current[4] = el)} className="section">
<BearBullTeam />    
</div>
</div>

<button onClick={handleScrollTop} className="scroll-to-top">
        <ScrollToTopReversed />
      </button>*/}</div>
    </>
   
  );
};

export default BearBullLanding;